import {Component} from "./Component";
import {gsap} from "gsap";
import {createLogger} from "../util/logger";


const console = createLogger("PageHeader");

export class PageHeader extends Component {
    static name = "page-header";

    get name() {
        return PageHeader.name;
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement|null}
         */
        this.$title = this.querySelector(".page-header__title");

        /**
         * @type {HTMLElement|null}
         */
        this.$text = this.querySelector(".page-header__text");

        /**
         * @type {HTMLElement[]}
         */
        this.$buttons = this.querySelectorAll(".page-header__buttons li").map(el => el.firstElementChild);

        this._init();

    }

    _init() {

        const tl = gsap.timeline();

        tl.to(Array.from(this.$title.querySelectorAll(".line span")), {
            stagger: 0.2,
            duration: .7,
            delay: 0.5,
            ease: "power4.out",
            y: "-=100%",
        });

        if (this.$text) {
            tl.to(this.$text, {
                opacity: 1,
                y: 0,
                duration: 0.4,
                ease: "power4.out",
            }, "-=0.4");
        }

        tl.to(this.$buttons, {
            opacity: 1,
            duration: .7,
            stagger: 0.3,
            y: 0,
            ease: "power4.out",
        }, "-=0.4");

    }
}
